import { WidgetResources } from "./widget";

const resources: WidgetResources = {
  documentCentre: {
    components: {
      searchBarTitle: "Formulaires et guides",
      documentCentreTitle: "Centre de documentation"
    },
    tabs: {
      searchLabel: "Recherche",
      favouriteLabel: "Favoris"
    },
    favourites: {
      titleLabel: "Favoris",
      unavailableMessage: "Les actions sur les favoris ne sont pas disponible pour l'instant. Veuillez réessayer plus tard.",
      moveUpTooltip: "Monter dans la liste",
      moveDownTooltip: "Descendre dans la liste",
      removeTooltip: "Retirer de la liste",
      showAllLabel: "Tous les favoris",
      showAllLabelInd: "Voir tous les favoris",
      errorMessage: "Impossible d’obtenir la liste des documents favoris.",
      noDocumentMessage: "Aucun document favori n’a été trouvé. Pour ajouter un document aux favoris, cliquez sur l’icône « Ajouter aux favoris » présent sur chaque résultat d’une recherche de document."
    }
  },
  news: {
    titleLabel: "Actualités",
    buttonLabel: "Toutes les actualités"
  },
  login: {
    title: "Accès sécurisé",
    submitButton: "Se connecter",
    registrationLabel: "S'inscrire"
  },
  application: {
    titleLabel: "Outils et applications"
  },
  promotion: {
    correspondenceLanguageEnglish: "Anglais",
    correspondenceLanguageFrench: "Français",
    emailHome: "Maison",
    emailWork: "Travail",
    phoneNumberCell: "Cellulaire",
    phoneNumberFax: "Télécopieur",
    phoneNumberHome: "Maison",
    phoneNumberWork: "Travail"
  },
  contract: {
    title: "Recherche",
    subTitle: "Tous les contrats de",
    newSearch: "Nouvelle recherche"
  },
  contractList: {
    noContractTitle: "No contrat",
    descriptionTitle: "Description",
    returnButton: "Retour au client"
  },
  instabilityMessage: {
    baseMessage: "Veuillez noter que certaines sections ne sont pas disponibles pour le moment. Nous sommes désolés des inconvénients que cela peut vous causer.",
    investiaAdvisorMessage: `Veuillez noter que certaines sections ne sont pas disponibles pour le moment. Nous sommes désolés des inconvénients que cela peut vous causer.<br/>
                                 Vous pouvez tout de même accéder à Univeris en cliquant sur ce lien :  <a href="https://investia.iaas.ca">Univeris</a>`,
    fundexAdvisorMessage: `Veuillez noter que certaines sections ne sont pas disponibles pour le moment. Nous sommes désolés des inconvénients que cela peut vous causer.<br/>
                               Vous pouvez tout de même accéder à Univeris en cliquant sur ce lien :  <a href="https://advisor.fundex.com/upm">Univeris</a>`,
    iaAdvisorMessage: `Veuillez noter que certaines sections ne sont pas disponibles pour le moment, plus précisément l’accès à la documentation. Nous travaillons activement
                           à résoudre la situation.<br/>Nous sommes désolés des inconvénients que cela peut vous causer.<br/>Merci de votre compréhension.`
  }
};
export default resources;